import { render, staticRenderFns } from "./documentInfo.vue?vue&type=template&id=19189d37&scoped=true&"
import script from "./documentInfo.vue?vue&type=script&lang=js&"
export * from "./documentInfo.vue?vue&type=script&lang=js&"
import style0 from "./documentInfo.vue?vue&type=style&index=0&id=19189d37&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19189d37",
  null
  
)

export default component.exports